import { absoluteUrl } from '@/lib/seo/canonical-url';
import {
  buildProductItemList,
  type ItemListProduct,
} from '@/lib/seo/product-item-list';

interface ProductListJsonLdProps {
  name: string;
  path: string;
  products?: readonly ItemListProduct[];
}

/** CollectionPage + ItemList for listing pages whose products are server-rendered. */
export default function ProductListJsonLd({
  name,
  path,
  products,
}: ProductListJsonLdProps) {
  const pageUrl = absoluteUrl(path);
  const itemList = buildProductItemList(`${pageUrl}#products`, products);
  if (!itemList) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        '@id': pageUrl,
        name,
        url: pageUrl,
        inLanguage: 'pt-BR',
        mainEntity: { '@id': itemList['@id'] },
      },
      itemList,
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
